import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hamiltonNJConfig } from "./data";

export default function HamiltonNJPage() {
  return <CityPageTemplate config={hamiltonNJConfig} />;
}